import { render, staticRenderFns } from "./StudioCommunityGroupCard.vue?vue&type=template&id=217c6c0e&scoped=true&"
import script from "./StudioCommunityGroupCard.vue?vue&type=script&lang=ts&"
export * from "./StudioCommunityGroupCard.vue?vue&type=script&lang=ts&"
import style0 from "./StudioCommunityGroupCard.vue?vue&type=style&index=0&id=217c6c0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c6c0e",
  null
  
)

export default component.exports